import { atom } from 'jotai'
import { atomWithReset } from 'jotai/utils'

export type LastPageTracked = {
  pageCategory?: string
  pageType: string
  pageSubCategory1?: string
  pageSubCategory2?: string
  pageSubCategory3?: string
  productReference?: string
}

export const lastPageTrackedAtom = atomWithReset<LastPageTracked>({
  pageCategory: undefined,
  pageType: '',
  pageSubCategory1: undefined,
  pageSubCategory2: undefined,
  pageSubCategory3: undefined,
})

/**
 * Atom to store tracking consent status
 *
 * undefined: pending user decision
 * true: consent given
 * false: consent denied
 */
export const trackingConsentAtom = atom<boolean>(false)
